var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"validate-login"},[_c('LoadingPage',{attrs:{"is-loading":_vm.isLoading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }